import React from 'react'

import * as S from './styles'

import ModalDefault from '../../../ui/Modals/ModalDefault'

function ModalSignContract(props) {
  return (
    <ModalDefault
      active={props.active}
      title='Você ainda possui contrato(s) para assinar'
      onClick={() => props.setSignContractModalActive(false)}
    >
      <p>
        Por favor verifique seu e-mail e assine os contratos restantes para fazer o login.
      </p>

      {props.contractDocs.length > 0 && (
        <S.Title>Documentos:</S.Title>
      )}

      {props.contractDocs.map(doc => (
        <S.Item>{doc.titulo} - {doc.assinado ? 'Assinado' : 'Não assinado'}</S.Item>
      ))}
    </ModalDefault>
  )
}

export default ModalSignContract
